import BasicLayout from "./BasicLayout";

const Step2 = ({
    activationType,
    state,
    setState,
    setLoad,
    licenseTypesConfig,
}) => {
    function selectType(type) {
        setLoad(false);

        setState((state) => ({
            ...state,
            data: {
                ...state.data,
                subtype: type,
            },
        }));
    }

    return (
        <>
            <BasicLayout
                title="Tipologia licenza"
                subtitle={
                    <>
                        Scegli la tipologia di licenza della tua piattaforma
                        Proxima{" "}
                        <span className="capitalize">{activationType}</span>.
                    </>
                }
                content={
                    <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
                        {licenseTypesConfig?.map(({ key }) => (
                            <div
                                key={key}
                                onClick={() => selectType(key)}
                                className={`!z-5 relative flex cursor-pointer items-stretch rounded-[8px] bg-white bg-clip-border py-6 px-4
                                 text-center text-gray-800 shadow-lg shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none md:py-4 md:px-6 
                                 ${
                                     state?.data?.subtype === key
                                         ? "border-2 border-blue-500 text-blue-500"
                                         : ""
                                 }`}
                            >
                                <div className="w-full self-center">
                                    <p className="cursor-pointer self-center text-xl font-medium capitalize italic leading-none text-blue-600">
                                        {key}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                }
            />
        </>
    );
};

export default Step2;
